import RSAA from "redux-api-middleware/es/RSAA";
import {defaultHeaders} from "../../../common/js/crud-actions";

export const downloadDocument = (id) => {
    let namespace = 'api/v1';

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/documents/${id}/download`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                'DOCUMENT_DOWNLOAD',
                'DOCUMENT_DOWNLOAD_SUCCESS',
                'DOCUMENT_DOWNLOAD_ERROR',
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
};

export const resendToSap = (id) => {
    let namespace = 'api/v1';

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/documents/${id}/resend_to_sap`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                'DOCUMENT_RESEND_SAP',
                'DOCUMENT_RESEND_SAP_SUCCESS',
                'DOCUMENT_RESEND_SAP_ERROR',
            ],
            credentials: 'same-origin'
        },
        auth: true
    };
};

export const documentUpload = (values) => {
    let namespace = 'api/v1';

    const data = new FormData();
    if (values.file !== undefined) {
        data.append('resource[file]', values.file);
    }
    data.append('resource[type]', values.type);
    data.append('resource[employee_id]', values.employee_id);

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/documents/`,
            method: 'POST',
            types: [
                'DOCUMENT_UPLOAD',
                'DOCUMENT_UPLOAD_SUCCESS',
                'DOCUMENT_UPLOAD_ERROR',
            ],
            credentials: 'same-origin',
            body: data
        },
        auth: true
    }

};
